// Provedores de IA que o cliente pode usar: onde criar a chave e o tipo dela no cofre do motor.
export const PROVEDORES = [
  { id: 'openrouter', kind: 'openrouter', link: 'https://openrouter.ai/keys' },
  { id: 'google', kind: 'gemini', link: 'https://aistudio.google.com/apikey' },
  {
    id: 'openai',
    kind: 'openai',
    link: 'https://platform.openai.com/api-keys',
  },
  {
    id: 'anthropic',
    kind: 'anthropic',
    link: 'https://console.anthropic.com/settings/keys',
  },
  {
    id: 'deepseek',
    kind: 'deepseek',
    link: 'https://platform.deepseek.com/api_keys',
  },
];

// Modelos liberados de um provedor, do mais barato ao mais caro (custo_mil = R$ por 1 000 conversas).
export const modelosDoProvedor = (modelos, provedor) =>
  (modelos || [])
    .filter(item => item.provider === provedor)
    .sort((a, b) => a.custo_mil - b.custo_mil);
